import Sawal_Back_Small from "../components/books/asset/Sawal_Back_Small.png"
import Sawal_Front_Small from "../components/books/asset/Sawal_Front_Small.png"
import Sawal_Back_Big from "../components/books/asset/Sawal_Back_Big.png"
import Sawal_Front_Big from "../components/books/asset/Sawal_Front_Big.png"

import Isha_Back_Small from "../components/books/asset/Isha_Back_Small.png"
import Isha_Front_Small from "../components/books/asset/Isha_Front_Small.png"
import Isha_Back_Big from "../components/books/asset/Isha_back_Big.png"
import Isha_Front_Big from "../components/books/asset/Isha_Front_Big.png"

import RR_Back_Small from "../components/books/asset/RR_Back_Small.png"
import RR_Front_Small from "../components/books/asset/RR_Front_Small.png"
import RR_Back_Big from "../components/books/asset/RR_Back_Big.png"
import RR_Front_Big from "../components/books/asset/RR_Front_Big.png"

const booksData = {
  isavasyopanishad: {
    isEbook: false,
    title: "Isavasyopanishad - Hindi Mein Geetantaran",
    bookDescription:
      "भारत के वैदिक साहित्य के आध्यात्मिक आयाम में विविध उपनिषद् उपवेद के रूप में जाने जाते हैं और उनमे सबसे पहला उपनिषद् ईशावास उपनिषद् कहलाता है | ईशावास उपनिषद् में मात्र 18 मंत्र हैं जिनके माध्यम से ज्ञान और कर्म की अतिसूक्ष्म और गहन किन्तु सहज मीमांसा की गई है | वैदिक साहित्य की प्रेरणा की अच्छी पकड़ रखने वाले मनीषी प्रोफ. प्रेम मोहन लखोटिया द्वारा प्रस्तुत है पद्य प्रवाह में इस उपनिषद् के मंत्रों का हिंदी में ललित रूपान्तरण | इस रूपान्तरण में मंत्र ऋचाओं के शब्दों के संदर्भित अर्थ के भावों का पल्लवन किया गया है | सुरुचिपूर्ण मौलिकता के साथ यह पुस्तक इसके पाठकों को अपने जीवन में अनुसरणीय सत्य के संधान के लिए प्रेरित करती है |",
    aboutAuthor: `
    सात दशक से अपवादहीन निरंतरता के साथ दैनिक चिंतन लेखन, मूलतया पद्य में, अन्य विधा गद्य में।
    औद्योगिक व्यवसाय एवं अभिरुचिगत शिक्षण से अवकाश लेने के बाद से बहुभाषी स्वाध्याय, साहित्य सृजन और अनुवाद के साथ साथ बालकों और युवाओं के संस्कार पल्लवन में रत।
    अनेक बार सम्मानित एवं विभूषित।
    अब तक विविध भाषा की प्राय: 35 हजार से अधिक रचनाओं का हिंदी, अंग्रेजी, फ्रेंच, बंगला, उर्दू और राजस्थानी में मनीषापूर्ण लेखन।
    प्राय: 3500 रचनाओं का राष्ट्रीय और अंतर्राष्ट्रीय स्तर पर प्रकाशन और प्रसारण।
    रचना कृतियाँ :-
    सात बहुचर्चित एवं सम्मानित मौलिक काव्य और चिंतन सूक्त कृतियों का स्वतंत्र प्रकाशन। कई विशिष्ट संकलनों में रचनाएँ समादृत।
    अब तक 14 पुस्तकों का सकल अनुवाद और 4  पत्रिकाओं का सम्पादन।`,

    images: [
      {
        thumbnail: Isha_Front_Small,
        fullSize: Isha_Front_Big,
      },
      {
        thumbnail: Isha_Back_Small,
        fullSize: Isha_Back_Big,
      },
    ],
    meta: {
      languages: ["Hindi"],
      binding: "PaperBack",
      isbn13: "9788194683308",
      pages: "56",
      weight: "100 gm",
      publisher: "Wisdom Words Publishing",
      dimension: "5 x 7 inch",
      "publication Date": "27 July 2020",
    },
    buyLinks: [
      {
        country: "India",
        platforms: [
          {
            name: "Amazon",
            link:
              "https://www.amazon.in/Ishavasyopanishad-Hindi-Mein-Geetantaran-Mohan-Lakhotia/dp/8194683300/ref=sr_1_1?crid=1LG96N9ICPYY6&dchild=1&keywords=prem+mohan+lakhotia&qid=1598527091&sprefix=prem+mohan%2Caps%2C287&sr=8-1",
          },
          {
            name: "Flipkart",
            link:
              "https://www.flipkart.com/isavasyopanishad/p/itm0ad6e9af70c83?pid=9788194683308&lid=LSTBOK97881946833082J9PHB&marketplace=FLIPKART&srno=s_1_1&otracker=search&otracker1=search&fm=SEARCH&iid=fddf3462-a25e-49aa-9c38-6bb68a041080.9788194683308.SEARCH&ppt=sp&ppn=sp&ssid=fn1tsxyocg0000001598528036451&qH=9ba113e86be6c013",
          },
          {
            name: "Snapdeal",
            link:
              "https://www.snapdeal.com/product/ishavasyopanishad-hindi-me-geetantaran/641775330840",
          },
        ],
      },
    ],
    contributors: [
      {
        name: "Prem Mohan Lakhotia",
        profile: "",
        contributedAs: "Author",
      },
      {
        name: "Narendra Sharma",
        profile: "",
        contributedAs: "Preface",
      },
    ],
    pricing: {
      India: {
        mrp: "200",
        price: "180",
        discount: {
          percent: "10",
          amount: "20",
        },
      },
      USA: {
        mrp: "6",
        price: "6",
        discount: {
          percent: "0",
          amount: "0",
        },
      },
    },
  },
  sawalSamayKe: {
    isEbook: false,
    title: "Sawal Samay Ke Jawab Zimmedari Ke",
    bookDescription:
      "कुछ पुस्तकों को पढ़ना इस कारण से आवश्यक हो जाता है क्योंकि वे जीवन के विभिन्न आयामों के प्रति एक नवीन दृष्टिकोण प्रदान करती हैं। इस पुस्तक के विषय जीवन के ऐसे आयामों को छूते हैं, जिन पर चिंतन करना वर्तमान समय की प्राथमिक आवश्यकता सा प्रतीत होता है। यह पुस्तक हमारे आज के विकास और प्रगति के बीच उठे हुए विरोधाभास पर कुछ ठोस सवाल उठाती है, और उनके समाधान पर लेखिका के मन्तव्य भी स्पष्टता के साथ प्रस्तुत करती है। यह सारे लेख सहचिन्तन के परिणाम है और यह सहचिन्तन की गोष्ठियों में रखे गए हैं। इससे यह परिक्षित हो जाता है कि यह पुस्तक समाज के सचिंतन वर्ग को अवश्य ही एक नई सक्रियता प्रदान करेगी, इसलिए चेतना प्रसार के दृष्टिकोण से यह पुस्तक बहुत बड़ी सख्याँ में प्रसारित और विवेचित होनी चाहिए। विशेष कर नए चिंतन के सूत्र धार अध्यापक वर्ग के लिए यह पुस्तक शिक्षा का एक नया मार्ग प्रशस्त करती है। वर्तमान विकास की विसंगतियां नित्य नए आयाम में उभर कर हमारे विकास के परिणाम ज्यों बौने बनाने लगी हैं और हम यह सब देखते हुए भी जैसे संवेदनाहीन हो गए हैं। अब हमें घेरने लगी हैं वैयक्तिक चिंताएं जो आने वाले समय के लिए किसी भी भांति शुभ नहीं लगतीं। समय जैसे हर कदम पर हमसे तीखे सवाल पूछ रहा है और हमें ज़िम्मेदारी के साथ जवाब देने को विवश कर रहा है। सविता जी के मनीषापूर्ण मंतव्य मंथन मंच के सहचिंतन और गंभीर सामूहिक दृष्टिकोण की खोज़ में अग्रणी और सहायक रहें हैं। सरल भाषा में पूरी गंभीरता के साथ रचित, चयनित और सम्पादित ये लघु कथ्य पाठकों को अवश्य ही अत्यंत रोचक और प्रेरक लगेंगे।",
    aboutAuthor: `सविता लखोटिया  
    एक स्वाध्यायी कुशल गृहिणी। सीकर, राजस्थान में जन्मी और राजस्थान विश्वविद्यालय से हिंदी और संस्कृत में उल्लेखनीय योग्यता के साथ स्नातक परीक्षा में उत्तीर्ण। पत्रकारिता का अध्ययन। पूर्व निवास कोलकाता में। सम्प्रति जयपुर में। विभिन्न विद्यालयों में अध्यापन। अब निवृत्त। शिक्षा और सामाजिक परिवेश के बारे में गहन रुचि और चिंतन तथा सहभागिता।
    आध्यात्मिक चिंतन और सामाजिक मनीषा से जुड़ी अनेक आलेख रचनाओं का देश की प्रतिष्ठित पत्रिकाओं में प्रकाशन।
    वर्ष 2004 में तरुणों के लिए विशेष रूप से लिखित और सम्मानित एवं पुरस्कृत पुस्तक “भारत की योग विभूतियाँ” अत्यंत लोकप्रिय हुई।`,

    images: [
      {
        thumbnail: Sawal_Front_Small,
        fullSize: Sawal_Front_Big,
      },
      {
        thumbnail: Sawal_Back_Small,
        fullSize: Sawal_Back_Big,
      },
    ],
    meta: {
      languages: ["Hindi"],
      binding: "PaperBack",
      isbn13: "9788194683315",
      pages: "240",
      weight: "250 g",
      publisher: "Wisdom Words Publishing",
      dimension: "5.5 x 8.5 inch",
      "publication Date": "27 July 2020",
    },
    buyLinks: [
      {
        country: "India",
        platforms: [
          {
            name: "Amazon",
            link:
              "https://www.amazon.in/Sawal-Samay-Ke-Jawab-Zimmedari/dp/8194683319/ref=pd_sbs_14_1/262-0150251-3725378?_encoding=UTF8&pd_rd_i=8194683319&pd_rd_r=01eaed7d-0e03-4d37-a9c3-2dc48ef99c3f&pd_rd_w=CESwG&pd_rd_wg=EJA2R&pf_rd_p=00b53f5d-d1f8-4708-89df-2987ccce05ce&pf_rd_r=DP9SXQJRGY5TGXF399ZR&psc=1&refRID=DP9SXQJRGY5TGXF399ZR",
          },
          {
            name: "Flipkart",
            link:
              "https://www.flipkart.com/sawal-samay-ke-jawab-zimmedari/p/itmc03631638117e?pid=9788194683315&lid=LSTBOK9788194683315MFDLZ2&marketplace=FLIPKART&srno=s_1_1&otracker=search&otracker1=search&fm=SEARCH&iid=9e5ed623-7286-4bdc-b518-6be3a93312b2.9788194683315.SEARCH&ppt=sp&ppn=sp&ssid=bw47t6iyn40000001598529165520&qH=9acd3e36f62b5c5a",
          },
          {
            name: "Snapdeal",
            link:
              "https://www.snapdeal.com/product/sawal-samay-ke-jawab-zimmedari/636573505326#bcrumbSearch:Sawal%20Samay%20Ke%20Jawab%20Zimmedari%20Ke",
          },
        ],
      },
    ],
    contributors: [
      {
        name: "Savita Lakhotia",
        profile: "",
        contributedAs: "Author",
      },
      {
        name: "Mahendra Jain",
        profile: "",
        contributedAs: "Foreword",
      },
      {
        name: "Mukul Sharma",
        profile: "",
        contributedAs: "Introduction",
      },
    ],
    pricing: {
      India: {
        mrp: "300",
        price: "270",
        discount: {
          percent: "10",
          amount: "30",
        },
      },
      USA: {
        mrp: "10",
        price: "10",
        discount: {
          percent: "0",
          amount: "0",
        },
      },
    },
  },
  reflectingRipples: {
    isEbook: false,
    title: "Reflecting Ripples - Poetic Biography of Emotions and Experiences",
    bookDescription:
      "Collection of poems in English which is a Poetic Biography of Emotions and Experiences. This anthology is like a precious addition to the enormous riches of Indo-Anglian literature which has taken by now much deeper roots in Indian soil. The present anthology of poems contains 242 poems inclusive of both bigger and the mini-poems.",
    aboutAuthor:
      "… A high profile management professional and a master of management of his times … a think tank for leading industry groups of India – more than that! … An erudite and well-loved emeritus professor in the most distinguished Calcutta College … St. Xavier’s - playing the role of life guide for thousands – more than that! … A candid social worker … a Lion-hearted leader (an awarded member of Lions Clubs International) … a wide traveller of the spirit within and beyond national boundaries … a bonding element of his happy family … a hobbyist … a prolific orator, voracious reader, a pensive thinker and writer with command over several languages and dialects … a nameologist – an analyst and advisor of personal names according to the ancient scriptural science of India with classical Sanskrit etymology … a true representative of his native and national life values and culture … a reflective spiritualist – always more than that!",

    images: [
      {
        thumbnail: RR_Front_Small,
        fullSize: RR_Front_Big,
      },
      {
        thumbnail: RR_Back_Small,
        fullSize: RR_Back_Big,
      },
    ],
    meta: {
      languages: ["English"],
      binding: "PaperBack",
      isbn13: "9788194683322",
      pages: "320",
      // weight: "350 gm",
      publisher: "Wisdom Words Publishing",
      dimension: "5.5 x 8.5 inch",
      "publication Date": "15-09-2020",
    },
    buyLinks: [
      {
        country: "India",
        platforms: [
          {
            name: "Amazon",
            link:
              "https://www.amazon.in/dp/8194683327/ref=sr_1_2?dchild=1&keywords=prem+mohan+lakhotia&qid=1598616128&sr=8-2",
          },
        ],
      },
    ],
    contributors: [
      {
        name: "Prem Mohan Lakhotia",
        profile: "",
        contributedAs: "Author",
      },
      {
        name: "Narendra Sharma",
        profile: "",
        contributedAs: "Foreword",
      },
      {
        name: "Jen Walls",
        profile: "",
        contributedAs: "Preface",
      },
    ],
    pricing: {
      India: {
        mrp: "400",
        price: "360",
        discount: {
          percent: "10",
          amount: "40",
        },
      },
      USA: {
        mrp: "$15",
        price: "$15",
        discount: {
          percent: "0",
          amount: "0",
        },
      },
    },
  },
}

export const { sawalSamayKe, isavasyopanishad, reflectingRipples } = booksData
export default booksData
